module.exports = __webpack_public_path__ + "img/menu2.4583e7ec.png";